import { CoordsApi } from './Coords/index';
import { TpApi } from '@/api/Coordinates/Tp';
import { CoordinatesSystemApi } from '@/api/Coordinates/CoordinateSystems';

export class CoordinatesApi {
  tps = new TpApi();
  coordinateSystems = new CoordinatesSystemApi();
  coords = new CoordsApi();
}
